import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { Button, Dialog, Stack } from '@prenuvo/halo-web';
import { useShallow } from 'zustand/react/shallow';

const ErrorDialog = () => {
  const { error, setErrorModal } = usePrenuvoStore(
    useShallow((state) => ({
      error: state.ui.error,
      setErrorModal: state.ui.methods.setErrorModal,
    })),
  );

  return (
    <Dialog
      title={{ children: error.title }}
      open={!!error.title || !!error.message}
      footer={
        <Stack gap={4} justification="end">
          <Button
            variant="text"
            onClick={() => {
              setErrorModal('', '');
              if (error.confirmation?.onClose) {
                error.confirmation?.onClose();
              }
            }}
          >
            Close
          </Button>
          {error.confirmation?.text && (
            <Button
              variant="primary"
              onClick={() => {
                setErrorModal('', '');
                if (error.confirmation?.action) {
                  error.confirmation?.action();
                }
              }}
            >
              {error.confirmation.text}
            </Button>
          )}
        </Stack>
      }
    >
      <p>{error.message}</p>
    </Dialog>
  );
};

export default ErrorDialog;
